import { Button, Card, Col, Collapse, Container, Form, Modal, Row, Stack } from "react-bootstrap";
import styles from "./ControlComponente.module.css";
import control from "../assets/img/controles/SKYAP_RC67M80X120.png";
import { SetStateAction, useEffect, useState } from "react";
import { ConsultaHistorialControl_Parametros, ConsultaHistorialControl_Respuesta, ConsultaHistorialControl_entrada, ConsultaSolicitudDeServicioProcessRequest, EBMHeaderRequest, ParametroList, SeguridadItem, SeguridadList, builtConsultaHistorialControlEntrada, builtConsultaSolicitudDeServicioProcessRequest, builtEBMHeaderRequest, builtParametroList, builtSeguridadItem, builtSeguridadList } from "../Commons/Services/ConsultaHistorialControl";
import { ConsultaWS } from "../Commons/ServiciosBase";
import { ConsultaControlRemotoRest_Parametros, ConsultaControlRemotoRest_Respuesta, ConsultaControlRemotoRest_entrada, ControlRemoto, builtConsultaControlRemotoRestEntrada } from "../Commons/Services/ConsultaControlRemotoRest";
import { AltaSolicitudDeServicio_Entrada, AltaSolicitudDeServicio_Parametros, AltaSolicitudDeServicio_Respuesta, CompraControlRemoto, ContratacionServicios, Direccion, InfoPPE, SolicitudDeServicio, builtAltaSolicitudDeServicio_Entrada, builtCompraControlRemoto, builtContratacionServicios, builtDireccion, builtInfoPPE, builtSolicitudDeServicio } from "../Commons/Services/AltaSolicitudDeServicioRest";
import ModalControl from "./ModalControl";
import ConfirmMessage from "../General/ConfirmMessage";
import Loading from "../General/Loading";
import control1 from "../assets/img/controles/SKYAP_RC67M80X120.png";
import control2 from "../assets/img/controles/SKYAP_SUPER_PLUS_HD80X120.png";
import control3 from "../assets/img/controles/SKYRC01M-V80x120.png";
import flecha from "../../src/assets/img/Iconos/flechaAbajo.svg";




const ControlComponente = () => {

  const [show, setShow] = useState(false);
  const [calle, setCalle] = useState(sessionStorage.getItem("StreetAddrCalle"));
  const [noExt, setNumExt] = useState(sessionStorage.getItem("AddrNumNumExt"));
  const [noInt, setNumInt] = useState(sessionStorage.getItem("AddrNumNumInt"));
  const [colonia, setColonia] = useState(sessionStorage.getItem("ProvinceColonia"));
  const [municipio, setMunicipio] = useState(sessionStorage.getItem(""));
  const [poblacion, setPoblacion] = useState(sessionStorage.getItem("CountyDelMun"));
  const [estado, setEstado] = useState(sessionStorage.getItem("StateEstado"));
  const [cp, setCP] = useState(sessionStorage.getItem("PostalCodeCP"));
  const [listaControles, setListaControles] = useState<any[]>();
  const [historialControles, setHistorialControles] = useState<any[]>();
  const [switchDireccion, setSwitchDireccion] = useState(true);
  const [acepta, setAcepta] = useState(false);
  const [status, setStatus] = useState("OK");
  const [message, setMessage] = useState("");
  const [showAlert, setShowAlert] = useState(false);
  const [loading, isLoading] = useState(false);
  const [indices, setIndices] = useState<any>([]);

  const controlesImg = [{id:"SKYAP_RC67M80X120.png", img: control1}, {id:"SKYAP_SUPER_PLUS_HD80X120.png", img: control2}, 
                        {id:"SKYRC01M-V80x120.png", img: control3}];
  
  
  const switchAddress = () => {
    setSwitchDireccion(!switchDireccion);

  }

  const handleShow = (i:any) => {
    setListaControles(
      listaControles!.map((e: any) =>
        e.id === i ? { ...e, isOpen: !e.isOpen } : { ...e, isOpen: false }
        
      )
    );
  };

  const aceptaTerminos = (e: any) => {
    setAcepta(e)

  };


  const compraControl = async (item:any) => {

    if (acepta) {

      isLoading(true);
      const  compraControl: CompraControlRemoto= builtCompraControlRemoto(
        `${item.Producto}`,
        "Y",
        `${item.TIPO_EQUIPO}`,
        `${item.Imagen}`,
        `${item.Manual}`,
      );
  
      const  direccion: Direccion= builtDireccion( 
        `${estado}`,
        `${poblacion}`,
        `${municipio}`,
        `${colonia}`,
        `${cp}`,
        `${calle}`,
        `${noExt}`,
        `${noInt}`,
      );
  
      
      const ContratacionServiciosRet: ContratacionServicios = builtContratacionServicios(
        `${sessionStorage.getItem("Paquete")}`,
        "",
        "",       
        "",
        "",
        "N"
      );
  
      const infoPPE: InfoPPE = builtInfoPPE("","","","","","","","","","","","","0","","","","","");
  
      const SolicitudDeServicioRet: SolicitudDeServicio = builtSolicitudDeServicio(
        `${sessionStorage.getItem("cuenta")}`,
        "Tramites",
        "Control Remoto",
        "Web - Tipo Control: " + item.TIPO_EQUIPO +" Direccion: "+ calle + " , no. Ext: "+ noExt +", no. Int: "+noInt+
            ", , colonia: "+colonia +" ciudad: "+poblacion +", delegacion o municipio: "+municipio+ ", estado: "+estado+", cp: "+cp,
        "",
        `${sessionStorage.getItem("RowIdContacto")}`,
        `${sessionStorage.getItem("EmailNotif")}`, //l_MailConfirmacion: string,
        `${sessionStorage.getItem("pais")}`, //l_Pais: string,
        `${sessionStorage.getItem("marketclass")}`, //l_TipoCuenta: string,
        `${sessionStorage.getItem("NombreSuscriptor")}`, //l_NombreSuscriptor: string,
        null,
        direccion,
        ContratacionServiciosRet,
        compraControl,
        null,
        infoPPE,
        null,
        null,
        "HIJUMP",
        `${sessionStorage.getItem("idSesion")}`
      );
      const AltaSolicitudDeServicioDO: AltaSolicitudDeServicio_Entrada = builtAltaSolicitudDeServicio_Entrada(SolicitudDeServicioRet);
      let par = AltaSolicitudDeServicio_Parametros(AltaSolicitudDeServicioDO);
      let AltaSolicitudDeServicioRespuesta: AltaSolicitudDeServicio_Respuesta = await ConsultaWS(par);
      
        if (AltaSolicitudDeServicioRespuesta.resultado === "0") {
          setStatus("OK");
          setMessage("Su solicitud de compra ha sido creada exitosamente.Su número de referencia es: " +
          AltaSolicitudDeServicioRespuesta.NumeroSolicitud);

          handleShow(item.id);
          setShowAlert(true);
          setTimeout(() => {
            setShowAlert(false);
          }, 3000);
          isLoading(false);
          

        } else {
          setStatus("ERROR");
          setMessage("Ocurrió algo inesperado, comuníquese a Servicio a Clientes lo antes posible");
          setShowAlert(true);
          setTimeout(() => {
            setShowAlert(false);
          }, 3000);
          
          isLoading(false);

        }
  

      } else {
      setStatus("ERROR");
      setMessage("Aceptar términos y condiciones.");
      setShowAlert(true);
      setTimeout(() => {
        setShowAlert(false);
      }, 3000);


      
    }

   }


   const obtieneListaControles = async () => {

    isLoading(true);
    const entrada: ConsultaControlRemotoRest_entrada = builtConsultaControlRemotoRestEntrada( sessionStorage.getItem("banderaHD")!,
                                                                                              sessionStorage.getItem("organizacion")!,
                                                                                              sessionStorage.getItem("marketclass")!);
    let parametros = ConsultaControlRemotoRest_Parametros(entrada);
    let respuesta: ConsultaControlRemotoRest_Respuesta = await ConsultaWS(parametros);

    if (respuesta.resultado === "0" && respuesta.ListaControlRemoto.ControlRemoto.length > 0) {

      const ar: object[] = [];
      const arTarjetas :any[]= JSON.parse(sessionStorage.getItem("tarjetas")!); 

      arTarjetas.forEach((tarjeta:any)=>{

        let ird = (tarjeta.IRD).slice(0,6);

        respuesta.ListaControlRemoto.ControlRemoto.forEach((element: any, i: number) => {
          let series: string[] = element.TIPO_EQUIPO.split(";");

          series.forEach((serie:string)=>{
            if (serie === ird) {
              ar.push(element);    
            }
          });
        
        });
        
        isLoading(false);
      });


        const temp = ar.map((e, i) => ({ ...e, id: i }));
        setListaControles(temp.map((e) => ({ ...e, isOpen: false })));


    } else {
      isLoading(false);
    }
    
   }

   const obtieneHistorialControl = async () => {

    isLoading(true);
    const consultaSolicitudDeServicioProcess:ConsultaSolicitudDeServicioProcessRequest = builtConsultaSolicitudDeServicioProcessRequest(
      "Tramites",
      `${sessionStorage.getItem("rowId")}`,
      "Control Remoto"
    );

    const parametroList : ParametroList = builtParametroList([]);
    const seguridadItem : SeguridadItem = builtSeguridadItem("","SEL_SKY","");
    let ar = [seguridadItem];
    const seguridadList : SeguridadList = builtSeguridadList(ar);

    const eBMHeaderRequest: EBMHeaderRequest = builtEBMHeaderRequest("ListadoHistorialControlRemoto",parametroList,seguridadList,"Web");

    const entrada: ConsultaHistorialControl_entrada = builtConsultaHistorialControlEntrada( consultaSolicitudDeServicioProcess, 
                                                                                            eBMHeaderRequest);
    let parametros = ConsultaHistorialControl_Parametros(entrada);
    let respuesta: ConsultaHistorialControl_Respuesta = await ConsultaWS(parametros);

    if (respuesta.ConsultaSolicitudDeServicioProcessResponse.resultado === "0") {
      setHistorialControles(respuesta.ConsultaSolicitudDeServicioProcessResponse.DetalleSolicitudDeServicio);
      isLoading(false);

      let arreglo = respuesta.ConsultaSolicitudDeServicioProcessResponse.DetalleSolicitudDeServicio;
      let arTemp:any = [];
      if (arreglo?.length) {
        arreglo.forEach((item, index)=>{
          arTemp.push({id:index, isOpen:false});
        });
      }

      setIndices(arTemp);

    }else{
      isLoading(false);
    }

    
   }

   const formatoFecha = (fecha: string) => {
    let ar = [];
    let f = "";

    if (fecha !== null) {
      ar = fecha.split("-");
      f = ar[2] + "/" + ar[1] + "/" + ar[0];
    }

    return f;
  };

  function manejaCollapse(key: number) {
    setIndices(
      indices.map((e: any) =>
        e.id === key? { ...e, isOpen: !e.isOpen } : { ...e, isOpen: false }
      )
    );
  }


  useEffect(() => {
    obtieneListaControles();
    obtieneHistorialControl();


  }, []);

    return(
      <>
      <Loading isLoading={loading} />
      <ConfirmMessage status={status} message={message} showAlert={showAlert}/>
      { listaControles !== undefined && listaControles.length > 0?
        (listaControles.map((item: any, index: number) => (
          <>
            <Card  className={styles.card} key={index}>
              <Card.Body  className={styles.cardBody}>
              <Row>
                <Col sm={12} md={1} lg={2} xl={2} xxl={1}  className={styles.colImagen}> <img src={control} /></Col>
                <Col sm={12} md={7} lg={7} xl={7} xxl={8} className={styles.colInfo}>
                  <div>
                        <a className={styles.tituloCard} onClick={()=>handleShow(index)}><b>{item.Producto}</b></a>
                        <p className={styles.subTituloCard}>{item.Descripcion}</p>
                        <p className={styles.precio}><b>$ {item.Precio}</b></p>
                  </div>
                </Col>
                <Col sm={12} md={4} lg={3} xl={3} xxl={3}  className={styles.colBoton}>
                    <Button className={styles.boton} href={item.Manual} target="_blank">Manual de usuario</Button>
                </Col>
              </Row>
              </Card.Body>
            </Card>
            {/* <ModalControl status={show} cierra={handleClose} control={item}/> */}
            <Modal show={item.isOpen}  size="xl" centered>
              <Modal.Header closeButton style={{ borderBottom: "none" }} onClick={()=>handleShow(index)}></Modal.Header>
                <Modal.Body className={styles.contenedorMod}>
                  <div>
                    <h2 className={styles.tituloModal}>Solicitud de Control Remoto</h2>
                  </div>
                  <Container>
                    <Row>
                      <Col xs={12} sm={12} md={12} lg={8} xl={8} xxl={8}>
                      <div>
                        <h3 className={styles.subtituloModal}>Dirección de envío</h3>
                      </div>
                      <Col>
                        <Card  className={styles.card}>
                            <Card.Body  className={styles.cardBodyModal}>
                              {
                                switchDireccion ?
                                (<Container>
                                  <Row>
                                    <Col>
                                      <p className={styles.textoModal}>Calle: <span><b>{calle}</b></span></p>
                                      <p className={styles.textoModal}>Num. Ext.: <span><b>{noExt}</b></span></p>
                                      <p className={styles.textoModal}>Num. Int.:  <span><b>{noInt}</b></span></p>
                                      <p className={styles.textoModal}>Colonia: <span><b>{colonia}</b></span></p>
                                    </Col>
                                    <Col >
                                      <p  className={styles.textoModal}>Municipio: <span><b>{municipio}</b></span></p>
                                      <p  className={styles.textoModal}>Ciudad: <span><b>{poblacion}</b></span></p>
                                      <p  className={styles.textoModal}>Estado:  <span><b>{estado}</b></span></p>
                                      <p  className={styles.textoModal}>C.P. <span><b>{cp}</b></span></p>
                                    </Col>
                                  </Row>

                                </Container>):
                                (<Container>
                                  <Form className={styles.formSmall}>
                                    <Row className={styles.espacioInput}>
                                      <Col className={styles.separaInputSmall}>
                                        <span className={styles.textoModal}><b>Calle</b></span>
                                        <Form.Control name="calle" value={calle!} onChange={(e)=>setCalle(e.target.value)}/>
                                        <span className={styles.textoModal}><b>Num. Ext.:</b></span>
                                        <Form.Control name="numExt" value={noExt!} onChange={(e)=>setNumExt(e.target.value)}/>
                                        <span className={styles.textoModal}><b>Num. Int.:</b></span>
                                        <Form.Control name="numInt" value={noInt!} onChange={(e)=>setNumInt(e.target.value)}/>
                                        <span className={styles.textoModal}><b>Colonia:</b></span>
                                        <Form.Control name="colonia" value={colonia!} onChange={(e)=>setColonia(e.target.value)}/>
                                      </Col>
                                      <Col className={styles.separaInputSmall}>
                                        <span className={styles.textoModal}><b>Municipio:</b></span>
                                        <Form.Control name="poblacion" value={municipio!} onChange={(e)=>setMunicipio(e.target.value)}/>
                                        <span className={styles.textoModal}><b>Ciudad:</b></span>
                                        <Form.Control name="ciudad" value={poblacion!} onChange={(e)=>setPoblacion(e.target.value)}/>
                                        <span className={styles.textoModal}><b>Estado:</b></span>
                                        <Form.Control name="estado" value={estado!} onChange={(e)=>setEstado(e.target.value)}/>
                                        <span className={styles.textoModal}><b>C.P.:</b></span>
                                        <Form.Control name="cp" value={cp!} onChange={(e)=>setCP(e.target.value)}/>
                                      </Col>
                                    </Row>
                                  </Form>
                                  </Container>)
                              }
                              </Card.Body>
                        </Card>
                      </Col>
                
                      <Row>
                        <Col className={styles.alineaTerminos} xs={6} sm={5} md={5} lg={4}>
                              <Form.Check type="radio" label="He leído y acepto los" className={styles.textoModal2} checked={acepta} onChange={(e) => aceptaTerminos(e.target.checked)}/>
                        </Col>
                        <Col xs={6} sm={7} md={7} lg={8} >
                          <p><a href="https://www.sky.com.mx/terminos?tab=terminosycondiciones" className={styles.terminos}>Términos y condiciones</a></p>
                        </Col>
                      </Row>
                    </Col>

                    <Col xs={{span:12, order:"first"}} sm={12} md={12} lg={{span:4, order:"last"}} xl={4} xxl={4}>   
                      <div className={styles.alineaImagenModal}>
                      <img src={control} />
                      </div>  
                      
                      <p className={styles.textoModal2} style={{textAlign:"center"}}><b>{item.Precio}</b></p>
                      <p className={styles.textoModalDescripcion}>{item.Descripcion}</p>
                   </Col>
                  </Row>
                  <Row>
                    <Col className={styles.colBotonDireccion} xs={12} sm={6} md={6} lg={8} xl={8} xxl={8}>
                        {switchDireccion?
                          <Button className={styles.boton} onClick={switchAddress}>Enviar a otra dirección</Button>:
                          <Button className={styles.boton} onClick={switchAddress}>Dirección anterior</Button>
                        }
                          
                    </Col>
                      <Col xs={12} sm={6} md={6} lg={4} xl={4} xxl={4} className={styles.alineacionBotonesModal}>
                      
                            <Stack direction="horizontal">
                              <Button className={styles.botonCompra} onClick={()=>compraControl(item)}>Comprar</Button>
                              <Button className={styles.botonCancelarModalAviso} onClick={()=>handleShow(index)}><b>Cancelar</b></Button>
                            </Stack>
                      
                      </Col>
                    </Row>
                  </Container>
                </Modal.Body>
            </Modal>
          </>
        ))):
        <Card  className={styles.card}>
        <Card.Body  className={styles.cardBody}>
        <h2 className={styles.tituloModal}>No tenemos en existencia control remoto disponible para su equipo. Para más información por
              favor llame a Atención a Clientes y mencione el código CTR001.</h2>
        </Card.Body>
    </Card>
      }

      <Row>
          <Col>
            <h2 className={styles.tituloHistorial}>Histórico de Control remoto.</h2>
          </Col>
        </Row>
        <Row>

        </Row>
        <div id="big" className="d-none d-xl-block d-lg-block ">
        <Container fluid className={styles["subheaderRowGrid"] + " " + styles["historialGrid"]}>


        {historialControles !== undefined?
          (<Row className={styles["subheaderRowGrid"] + " " + styles["gridHeader"]}>
            <Col xs={2} sm={2} md={5} lg={4} xl={4}>
              <span>Número de solicitud</span>
            </Col>
            <Col xs={2} sm={2} md={2} lg={3} xl={3}>
              <span>Fecha</span>
            </Col>
            <Col xs={2} sm={2} md={5} lg={5} xl={5}>
              <span>Comentario</span>
            </Col>
          </Row>):<></>}

          {historialControles !== undefined?
              (historialControles.map((item: any, index: number) => (
                  <Row className={styles["subheaderRowGrid"] + " " + styles["grid"]} key={index} >
                    <Col xs={2} sm={2} md={5} lg={4} xl={4} className={styles["alignToLeft"]}>
                      <span>{item.NumeroDeSolicitud}</span>
                    </Col>
                    <Col xs={2} sm={2} md={2} lg={3} xl={3} className={styles["alignToLeft"]}>
                      <span>{item.FechaCreacion.slice(0,10)}</span>
                    </Col>
                    <Col xs={2} sm={2} md={5} lg={5} xl={5} className={styles["alignToLeft"]}>
                      <span>{item.Comentario}</span>
                    </Col>
                  </Row>
                ))):
                <p className={styles["avisoHistorial"]} >No has realizado una compra, cuando la realices aparecerá aquí.</p>
          }
          </Container>
        </div>

        {/***************************
        Inicia seccion responsiva
        *****************************/}

        <div id="small" className="d-lg-none d-xl-none">
          <Container>
           {historialControles !== undefined?
                      (historialControles.map((item: any, index:number) => (
                          <Card className={styles["cardSmall"]}>
                            <Row>
                              <Col className={styles["headerCard"]}>
                                <p className={styles["navegaSmall"]}><b>{item.NumeroDeSolicitud}</b></p>
                              </Col>
                              <Col>
                                <span>
                                  <Button
                                    style={{ background: "white",border: "none",float: "right"}} onClick={() => manejaCollapse(index)} >
                                    <img src={flecha} aria-controls="example-collapse-text" aria-expanded={indices[index].isOpen}
                                         className={ indices[index].isOpen === true? styles["rota"]: styles["noRota"]}/>

                                  </Button>
                                </span>
                              </Col>
                            </Row>
                            <Collapse in={indices[index].isOpen}>
                              <div id="example-collapse-text" className={styles["infoCardSmall"]}>
                                <p className={styles["subtituloInfo"]}><b>Fecha</b></p>
                                <p className={styles["infoCollapse"]}>{item.FechaCreacion.slice(0, 10)}</p>
                                <p className={styles["subtituloInfo"]}><b>Comentario</b></p>
                                <p className={styles["infoCollapse"]}>{item.Comentario}</p>
                              </div>
                            </Collapse>
                          </Card>
                        ))):
                        <p className={styles["avisoHistorial"]} >No has realizado una compra, cuando la realices aparecerá aquí.</p>
                      }
        </Container>
        </div>
      </>
  );
}

export default ControlComponente;